import { put } from "../base.ehq.model";
import { serialize } from "./user-resend-activation-email.serializer";
import { deserialize } from "../base.serializer";

export const resendUserActivationEmail = async (
  token: string,
  baseUrl: string,
  userId: number | string
): Promise<any> => {
  const queryPath = `${baseUrl}/users/${userId}/resend_email`;
  try {
    const serializedBody = await serialize({ id: userId });
    const res = await put(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
